import { RemoveAccessForInactiveMembersDocument } from "@pathwright/graphql-client/src/generated"

export default RemoveAccessForInactiveMembersDocument
